import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    bbFormattedDateString,
    isCurrentUserMemberOf,
    mapObject
} from "../../../../util/bbHelpers";
import {
    fetchCustomers,
    fetchUsers,
} from "../../../../actions";
import UserManagementFeedbackToggleSwitch from '../../controllers/UserManagementFeedbackToggleSwitch';
import BBDataTable from "../../tables/BBDataTable";
// import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Chip} from "@material-ui/core";
import {renderCellExpand} from "../../tables/DataGridRenderCellExpand";
import BBIconCredentialBadge from "../../../../assets/bbCustomIcons/BBIconCredentialBadge";
import BBIconConstructionTie from "../../../../assets/bbCustomIcons/BBIconConstructionTie";
import AdminUpdateUserRolesWidget from "../../admin/AdminUpdateUserRolesWidget";
import {CircularProgress} from "@mui/material";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";
import BBIconCheck from "../../../../assets/bbCustomIcons/BBIconCheck";
import BBIconRoundedDashNull from "../../../../assets/bbCustomIcons/BBIconRoundedDashNull";

// const useStyles = makeStyles((theme) => ({
//     button: {
//         margin: theme.spacing(1),
//     },
// }));

const DataTable = (props) => {

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {users, loadingUsers, loadingUsersError, loadingAddUserRole, loadingDeleteUserRole} = useSelector(({users}) => users);
  const {didJustCreateNewUser} = useSelector(({users}) => users.appMisc);

    const {customers, loadingCustomers} = useSelector(({customer}) => customer);
  const dispatch = useDispatch();
  const authUser = useSelector(({auth}) => auth.authUser);
  const isPartner = isCurrentUserMemberOf(authUser, "partner");
  const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
  const isStaff = isCurrentUserMemberOf(authUser, "staff");

  //   console.log("Customers is", customers);

  useEffect(() => {
    // console.group("UserManagementDataTable")
    // console.log("UserManagementDataTable here is the users in the store", users)
    if (!users && !loadingUsers) {
      console.log("Users is empty, fetching.")
      dispatch(fetchUsers());
    }
    if (users && didJustCreateNewUser){
        dispatch(fetchUsers());
    }

    if(!customers && !loadingCustomers){
        dispatch(fetchCustomers());
    }
    // console.groupEnd()
  }, [users, dispatch, loadingUsers, customers, loadingCustomers]);


  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    // const handleResetPWButton = (username, email) => {
    //     dispatch(resetPasswordAction({"username": username, "email": email}));
    // }
    //
    // const handleIsApprovedStatusButton = (userId, oldIsApprovedStatus) => {
    //     //toggle by sending the opposite of the current value
    //     dispatch(setUserIsApprovedAction({"userId": userId, "newIsApprovedStatus": !oldIsApprovedStatus}));
    // }
    //
    // const handleIsActiveStatusButton = (userId, oldIsActiveStatus) => {
    //     //toggle by sending the opposite of the current value
    //     dispatch(setUserIsActiveAction({"userId": userId, "newIsActiveStatus": !oldIsActiveStatus}));
    // }
    //
    // const handleNeedsPasswordResetStatusButton = (userId, oldNeedsPasswordResetStatus) => {
    //     //toggle by sending the opposite of the current value
    //     dispatch(setUserNeedsPasswordResetAction({"userId": userId, "newNeedsPasswordResetStatus": !oldNeedsPasswordResetStatus}));
    // }
    //
    // const handleDeleteUserButton = (userId) => {
    //     dispatch(deleteUserAction({"userId": userId}));
    // }

    const title = <span className={""}>
        All Users <Tooltip large={true} title={"Users and clients that have a registered account with BreachRisk"}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </span>;

  const userTableHeadings = [

      // { field: 'id', headerName: 'ID', hide: true, flex : 0.5, sortable: true, type: 'string', },
      { field: 'username', headerName: 'Username', hide: false, width : 140, sortable: true, type: 'string', renderCell: (params) => renderCellExpand(params,(params.value))},
      { field: 'fullName', headerName: 'Full Name', hide: false, width : 140, sortable: true, type: 'string',
          renderCell: (params) => renderCellExpand(params,
              params.value
      )},
      { field: 'first', headerName: 'First Name', hide: true, sortable: true, type: 'string', flex : 0.8, },
      { field: 'last', headerName: 'Last Name', hide: true, sortable: true, type: 'string', flex : 0.8, },
      { field: 'email', headerName: 'Email', sortable: true, type: 'string',
          renderCell: (params) =>
              renderCellExpand(params,(<Tooltip title={`Email ${params.row.first} ${params.row.last}`}>{params.value}</Tooltip>)), flex : 1.1},
      { field: 'dateJoined', headerName: 'Date Joined', sortable: true, type: 'dateTime',
          renderCell: (params) =>
              renderCellExpand(params,(<Tooltip title={bbFormattedDateString(params.value, "medium")}>
                      <span>
                          {bbFormattedDateString(params.value, "microYear")}
                      </span>
                  </Tooltip>)), width : 120, },

      { field: 'active', headerName: 'Active?', sortable: true, type: 'string', hide: true, renderCell: (params) => (
              <UserManagementFeedbackToggleSwitch
                  userId={params.row.id.toString()}
                  userProperty={"is_active"}
                  propertyDisplayName={params.row.active ? "Deactivate" : "Reactivate"}
                  disableInteraction={!isAdmin && !isStaff && !isPartner}
                  toolTip={"Toggle the activation status of this user. When set to Reactivate, user cannot log in."}
              />
          ), flex : 1},
      { field: 'approved', headerName: 'Approved?', sortable: true, type: 'string', hide: true, renderCell: (params) => (
              <UserManagementFeedbackToggleSwitch
                  userId={params.row.id.toString()}
                  userProperty={"is_approved"}
                  propertyDisplayName={params.row.approved ? "Approved" : "Not Approved"}
                  disableInteraction={!isAdmin && !isStaff }
                  toolTip={"Toggle the Approved status of this user. When Not Approved, user cannot log in."}
              />
          ), flex : 1},
      { field: 'activated', headerName: 'Email Verified', sortable: true, type: 'string', hide: false,
          renderCell: (params) => (
              <UserManagementFeedbackToggleSwitch
                  userId={params.row.id.toString()}
                  userProperty={"is_activated"}
                  // propertyDisplayName={params.row.approved ? "Verified" : "Not Verified"}
                  disableInteraction={!isAdmin && !isStaff }
                  toolTip={"Toggle the email verification status of this user. When Not Verified, user cannot log in."}
              />
          ), flex : 1},
      { field: 'resetPw', headerName: 'Reset PW?', sortable: true, type: 'string', hide: true, renderCell: (params) => (
              <UserManagementFeedbackToggleSwitch
                  userId={params.row.id.toString()}
                  userProperty={"needs_password_reset"}
                  propertyDisplayName={params.row.resetPw ? "Password Reset Pending" : "Force Password Reset"}
                  flipColorLogic
                  disableInteraction={!isAdmin && !isStaff && !isPartner}
                  toolTip={"Toggle the Password Reset status of this user. When set to Password Reset Pending, user will be forced to change password at the next login."}
              />
          ), flex : 1},
      {
          field: 'mfa_enabled', headerName: 'MFA', sortable: false, type: 'string', renderCell: (params) =>
              renderCellExpand(params, (params.value ? <BBIconCheck/> : <BBIconRoundedDashNull/>
              ))
          , flex : .5},
      {
          field: 'clientsAsString', headerName: 'Client Access', sortable: true, type: 'string', renderCell: (params) => {
          const customerChips = params.row.clients.map((customer, index) =>
              <Tooltip
                  key={`${params.row.username}_${customer.customer}_${customer.id}_${index}`}
                  title={`This user ${customers && customer && customer.manager ? "is a Manager for" : "has access to"}  ${customers && customers[customer.customer] ? customers[customer.customer].CustomerName : customer.customer}`}>
                  <span>
                      <Chip
                          label={`${customers && customers[customer.customer] ? customers[customer.customer].CustomerName : customer.customer}`}
                          // variant={"outlined"}
                          // avatar={names.avatar}
                          size={"small"}
                          color= "default" //{customer.manager ? "primary" : "default"}
                          // className={"mr-1"}
                          // onClick={!isTimelineButtonDisabled ? () => onClickToAttackTimeline(params.row.id) : null}
                          icon={customer.manager ? <BBIconCredentialBadge /> : null}
                      />
                  </span>
              </Tooltip>
          )
             return renderCellExpand(params, customerChips);

        }, flex : 1.5},
      {field: 'hasRoles', headerName: "Current Roles", sortable: true, type: "boolean", flex: 1, renderCell: (params) =>
            renderCellExpand(params, (!loadingDeleteUserRole[params.row.id]
                && !loadingAddUserRole[params.row.id]
                && params.row.roles
                && Array.isArray(params.row.roles)
                ? params.row.roles
                        .filter((role)=> role && role.role)
                        .map((role)=><span>
                    <Chip color={role.role.name === "admin" || role.role.name === "staff"
                        ? "primary"
                        : role.role.name === "partner"
                            ? "secondary"
                            : role.role.name === "Add Role"
                                ? "warning" : "default"}
                          icon={role.role.name !== "admin" ? null : <BBIconConstructionTie />}
                          size={"small"}
                          // clickable={true}
                          // onClick={()=>handleOpen(role.role)}
                          label={role.role.name !== "breachrisk_portfolio" ? role.role.name : "portfolio"}
                          variant={role.role.name === "admin" || role.role.name === "staff" ? "default" : role.role.name === "partner" ? "default" : "outlined"}>
                    </Chip>
                </span>)
                    : <CircularProgress/>
            ))},
      {
          field: 'roles', headerName: 'Update Roles', sortable: false, type: 'string', renderCell: (params) =>
              renderCellExpand(params, (<AdminUpdateUserRolesWidget rolesArray={params.value} userId={params.row.id}/>
                  ))
          , flex : 1},
      { field: 'actions', headerName: 'Activate', sortable: true, type: 'string', renderCell: (params) =>
              renderCellExpand(params, (<span>
              <UserManagementFeedbackToggleSwitch
                  user={params.row}
                  userId={params.row.id.toString()}
                  userProperty={"is_active"}
                  disableInteraction={!isAdmin && !isStaff && !isPartner}
                  toolTip={"Toggle the activation status of this user. When set to Reactivate, user cannot log in."}
              />
          </span>
              )
          ), width : 125},
      { field: 'passwordReset', headerName: 'Password Reset', sortable: true, type: 'string', renderCell: (params) =>
              renderCellExpand(params,(
              <span>
                  <UserManagementFeedbackToggleSwitch
                      user={params.row}
                      userId={params.row.id.toString()}
                      userProperty={"resetPw"}
                      flipColorLogic
                      disableInteraction={!isAdmin && !isStaff && !isPartner}
                      toolTip={"Toggle the Password Reset status of this user. When set to Password Reset Pending, user will be forced to change password at the next login."}
                  />
              </span>
              )
          ), width : 200},
      { field: 'earlyAccessTags', headerName: 'Early Access', sortable: true, type: 'string', renderCell: (params) =>
              renderCellExpand(params,(
                      <span>
                  <UserManagementFeedbackToggleSwitch
                      user={params.row}
                      userId={params.row.id.toString()}
                      userProperty={"hasEarlyAccess"}
                      flipColorLogic
                      disableInteraction={!isAdmin && !isStaff && !isPartner}
                      toolTip={"Toggle user's early access. Enabling will grant user level access to any user level features in Early Access Program."}
                      earlyAccessTags={params.value}
                  />
              </span>
                  )
              ), width : 150},


  ];

  //the data in this table is based on the data in the user table
  const tableData = users ? mapObject(users, (_, user) => {

      const earlyAccessTags = user && user.tags
          ? Object.values(user.tags)
              .filter((tag)=> tag.definition.id === 53 && tag.is_active)
            : null;

      const clientNames = user.customers && customers && Object.values(user.customers)
          .map((client)=> client.customer && customers[client.customer] && customers[client.customer].CustomerName)

    return (
        {
          id: user.id,
          username: user.username,
            first: user.first_name ? user.first_name : " ",
            last: user.last_name ? user.last_name: " ",
            fullName: `${user.first_name} ${user.last_name}`,
            email: <div><small><a href={`mailto:${user.email}`}>{user.email}</a></small></div>,
            dateJoined: user.date_joined ? bbDangerousStringToDate(user.date_joined): "N/A",
            active: user.is_active,
            approved: user.is_approved,
            activated: user.is_activated.toString(),
            resetPw: user.needs_password_reset,
            clients: user.customers,
            clientsAsString: clientNames && clientNames.join(' '),
            roles: user.roles,
            hasRoles: user.roles && Array.isArray(user.roles) && user.roles.length > 0,
            activate: null,
            passwordReset: null,
            tags: user.tags,
            earlyAccessTags: earlyAccessTags,
            hasEarlyAccess: earlyAccessTags && earlyAccessTags.length > 0,
            mfa_enabled: user.mfa_enabled,
        }
    )
  }) : null;

  // console.log(tableData);
    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr.sort((a,b)=> b.dateJoined - a.dateJoined);
    }


    console.log("users,", users, "tableDataAsArray", tableDataAsArray(), didJustCreateNewUser, "authUser", authUser)

    return (
        <div >
            {(users && !loadingUsers && !loadingUsersError) &&
            <BBDataTable
                columns={userTableHeadings}
                rows={ tableDataAsArray() }
                defaultPageSize={50}
                title={title}
                loading = {false}
                progressValue={100}
                bufferValue={100}
            />
            }
            {(loadingUsers) &&
            <BBDataTable
                columns={userTableHeadings}
                rows={[]}
                // defaultPageSize={5}
                title={title}
                loading = {true}
                // numSkeletonRows={( !(humans && !loadingHumansError) && (loadingHumans || loadingCustomers)) ? 5 : null}
            />
            }

        </div>
    );
  //
  // if (users && !loadingUsers && !loadingUsersError) {
  //   // console.log("UserManagementDataTable loading is finished here is the users in the store", users, "and table data", userTableDataAsArray())
  //   return (
  //       <div className={"animated fadeIn animation-duration-7"} >
  //           <ArrayDataTable tableData={userTableDataAsArray()} columnHeaders={userTableHeadings} title={"All Users"} defaultRowsPerPage={25}/>
  //       </div>
  //   );
  // } else if (loadingUsers) {
  //   return (
  //       <div className={""} >
  //           <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} title={"All Users"} loading={true} numSkeletonRows={10}/>
  //       </div>
  //   );
  //
  // } else {
  //   return (
  //       <div className={""} >
  //           <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} title={"All Users"} loading={true} numSkeletonRows={10}/>
  //       </div>
  //   );
  // }


}

export default DataTable